import classNames from "classnames";
import type React from "react";
import "./AlertNotification.css";
import { Flex } from "./Flex";
import Icon from "./Icon";

const AlertNotification = function AlertNotification({
    children,
    className,
}: {
    className?: string | undefined;
    children: React.ReactNode;
}) {
    return (
        <Flex.Row
            gap="medium"
            className={classNames(className, "alert-notification")}
            justifyContent="center"
        >
            <Icon.Error.Medium.E10 />
            <div>{children}</div>
        </Flex.Row>
    );
};

export default AlertNotification;
